// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lhGxe","title":"styles_title__7rKvf","subTitle":"styles_subTitle__pcczG"};